export const isValidPhoneNo = (phoneNo: string) =>
  /^[1-9]\d{6,14}$/.test(phoneNo);
